// angular
import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
// services
import { PwjToastService } from '@app/core/shared/services/app-toast.service';
// utils
import { DialogRef } from '@app/core/shared/utils/dialog/dialog-ref';
import { DIALOG_DATA } from '@app/core/shared/utils/dialog/dialog-tokens';
// types  & env
import { messageDialogDataType } from '@app/shared/types/message-dialog-data.type';
import { environment } from '@environments/environment';

@Component({
  selector: 'pwj-message-dialog',
  standalone: true,
  imports: [ButtonComponent, TranslateModule, NgOptimizedImage],
  templateUrl: './message-dialog.component.html',
  styleUrl: './message-dialog.component.scss',
})
export class MessageDialogComponent {
  public dialogData!: messageDialogDataType;
  public codeCopiedSuccessfully: boolean = false;

  // dependencies
  private readonly _toaster = inject(PwjToastService);
  private readonly _dialogRef = inject(DialogRef);
  public readonly data: messageDialogDataType = inject(DIALOG_DATA);

  constructor() {
    this.dialogData = this.data;
  }

  public close() {
    this._dialogRef.close();
  }

  // copy code functionality
  public onCopyOrderCode(link: string) {
    // copy text to clipboard
    navigator.clipboard
      .writeText(link)
      .then(_ => {
        this._toaster.success(
          'toastMessages.copyOrderCode',
          'toastMessages.successTitle'
        );
        this.codeCopiedSuccessfully = true;

        setTimeout(() => {
          this.codeCopiedSuccessfully = false;
        }, environment.copyTextTimeOut);
      })
      .catch(_ => {
        this._toaster.error('toastMessages.error', 'toastMessages.errorTitle');
      });
  }
}
